import React from "react";

const wordstat = require("#/assets/wordstat.ico");

const WordstatIcon = (props: any) => <img {...props} src={wordstat} alt="wordstat" />;

export default WordstatIcon;
